// extracted by mini-css-extract-plugin
export default {"root":"nrJZx5PmcK11X2dFuJ2t"};